<template>
	<div class="uiasd89d" :class="[size, status]">
		<label class="switch">
			<input
				type="checkbox"
				:id="id"
				:checked="value === true || value === 'true'"
				ref="checkbox"
				@change="$emit('input', $event.target.checked)"
			/>
			<span
				class="slider"
				tabindex="0"
				@keypress.enter="simulateClick"
				@focus="$emit('focus')"
				@blur="$emit('blur')"
			>
			</span>
		</label>
	</div>
</template>

<script>
export default {
	name: "j-base-toggle",
	props: {
		value: {
			validator(value) {
				return (
					value === null ||
					value === true ||
					value === "true" ||
					value === false ||
					value === "false"
				)
			},
			reguired: true,
			default: false
		},
		size: {
			required: false,
			default: "medium",
			validator(val) {
				return (
					val === null ||
					["xsmall", "small", "medium", "large", "xlarge"].includes(val)
				)
			}
		},
		status: {
			required: false,
			default: null,
			validator(val) {
				return val === null || ["error", "success", "warning"].includes(val)
			}
		},
		id: {
			type: String,
			required: false
		}
	},
	methods: {
		simulateClick() {
			this.$refs.checkbox.click()
		}
	}
}
</script>

<style src="./index.css" scoped />
